<ng-container *notAllowedPermissions="['incompleteLogin']">
  <nav *ngIf="getUserCurrent()" class="navbar navbar-expand-lg navbar-dark bg-dark top-bar">
    <a *roles="['ROLE_MCKAY']" class="navbar-brand"
       routerLink="/mckay/{{getUserCurrent().company.uniqid}}">{{ utilsService.getBrandName() }}</a>
    <a *roles="['ROLE_CLIENT']" class="navbar-brand"
       routerLink="/client/{{getUserCurrent().company.uniqid}}">{{ utilsService.getBrandName() }}</a>
    <div class="navbar-collapse" style="display: block !important;">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
        </li>
      </ul>
      <i *ngIf="(authenticationService.isLoading$ | async)" class="fa fa-spinner fa-spin"></i>
      <ul *ngIf="authenticationService.userAuthenticated" class="nav justify-content-end user-info-list">
        <li *ngIf="!authenticationService.userImpersonatedId" style="color: #CCCCCC">
          Logged in as&nbsp;{{ authenticationService.userAuthenticated?.name }}
          <span style="color: white">&nbsp;|&nbsp;</span>
        </li>
        <li *ngIf="authenticationService.userImpersonatedId" style="color: #CCCCCC">
          Impersonating {{ authenticationService.userCurrent?.name }}
          ({{ authenticationService.userCurrent?.company?.name }})
          <span style="color: white">&nbsp;|&nbsp;</span>
        </li>
        <li *permission="['canEditYours']" class="navbar-left">
          <a [routerLinkActiveOptions]="{exact: true}"
             routerLink="/{{getUserCurrent().company.uniqid}}/{{getUserCurrent().company.uniqid}}/{{getUserCurrent().uniqid}}/edit"
             routerLinkActive="active" style="cursor: pointer; color: #0088cc">Account</a>
          <span style="color: white">&nbsp;|&nbsp;</span>
        </li>
        <li *ngIf="authenticationService.userImpersonatedId" style="cursor: pointer; color: red">
          <a (click)="stopImpersonateUser()">End impersonation</a>
        </li>
        <li>
          <a (click)="authenticationService.logoutUser()" *ngIf="!authenticationService.userImpersonatedId"
             style="cursor: pointer; color: #0088cc">log out</a>
        </li>
        <li class="nav-item" *ngIf="authenticationService.userAuthenticated">
          <app-cart-widget></app-cart-widget>
        </li>
      </ul>
      <ul *ngIf="!authenticationService.userAuthenticated" class="nav justify-content-end">
        <li *ngIf="authenticationService.isLoading">
          <i class="fa fa-spinner fa-spin" style="color: white"></i>
        </li>
        <li>
          <a routerLink="/login" style="cursor: pointer; color: red; text-decoration-line: unset">Not authenticated!</a>
        </li>
      </ul>
    </div>
  </nav>
</ng-container>
